import { toast } from "../hooks/use-toast.ts";

export const showSuccess = (description: string, title = "Success") =>
  toast({ title, description });

export const showError = (description: string, title = "Error") =>
  toast({ title, description, variant: "destructive" });

export const showInfo = (description: string, title = "Info") =>
  toast({ title, description });
